import { Link, Tooltip } from '@mui/material'
import {
  EntityLookups,
  resolveEntityCellValue,
} from '../utils/entityDisplay'

interface EntityAccountCellProps {
  accountId?: string
  display: string
  tooltip?: string
  onOpenAccount?: (accountId: string) => void
}

export function EntityAccountCell({
  accountId,
  display,
  tooltip,
  onOpenAccount,
}: EntityAccountCellProps) {
  const content =
    accountId && onOpenAccount ? (
      <Link
        component="button"
        variant="body2"
        onClick={(e) => {
          e.stopPropagation()
          onOpenAccount(accountId)
        }}
        sx={{ fontWeight: 500, textAlign: 'inherit', verticalAlign: 'inherit' }}
      >
        {display}
      </Link>
    ) : (
      <span>{display}</span>
    )

  if (tooltip) {
    return <Tooltip title={tooltip}>{content}</Tooltip>
  }
  return content
}

export function renderEntityCell(
  key: string,
  value: unknown,
  lookups: EntityLookups,
  onOpenAccount?: (accountId: string) => void,
): React.ReactNode | null {
  const entityCell = resolveEntityCellValue(key, value, lookups)
  if (!entityCell) return null
  return (
    <EntityAccountCell
      accountId={entityCell.accountId}
      display={entityCell.display}
      tooltip={entityCell.tooltip}
      onOpenAccount={onOpenAccount}
    />
  )
}

export function AccountNameLink({
  accountId,
  accountById,
  onOpenAccount,
}: {
  accountId?: string
  accountById: Map<string, { businessName?: string; name?: string; id: string }>
  onOpenAccount?: (accountId: string) => void
}) {
  if (!accountId) return <span>—</span>
  const account = accountById.get(accountId)
  const display = account?.businessName || account?.name || `${accountId.substring(0, 10)}…`
  return (
    <EntityAccountCell
      accountId={accountId}
      display={display}
      tooltip={accountId}
      onOpenAccount={onOpenAccount}
    />
  )
}
